module.exports = __webpack_public_path__ + "static/media/0028.62a3e9f8.svg";